import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StopWithDetails } from '../../../../../types';
import { StopPlaceSignType } from '../../../../../types/stop-registry';
import { mapStopPlaceSignTypeToUiName } from '../../../../../utils/i18n';
import {
  DetailRow,
  LabeledDetail,
  optionalBooleanToUiText,
} from '../../Common';

const testIds = {
  container: 'SignageDetailsViewCard::container',
  signType: 'SignageDetailsViewCard::signType',
  numberOfFrames: 'SignageDetailsViewCard::numberOfFrames',
  signageInstructionExceptions:
    'SignageDetailsViewCard::signageInstructionExceptions',
  replacesRailSign: 'SignageDetailsViewCard::replacesRailSign',
};

type SignageDetailsViewCardProps = {
  readonly stop: StopWithDetails;
};

export const SignageDetailsViewCard: FC<SignageDetailsViewCardProps> = ({
  stop,
}) => {
  const { t } = useTranslation();

  const generalSign = stop.quay?.placeEquipments?.generalSign?.[0];

  const signType =
    generalSign?.privateCode?.value &&
    mapStopPlaceSignTypeToUiName(
      t,
      generalSign.privateCode.value as StopPlaceSignType,
    );

  return (
    <div data-testid={testIds.container}>
      <DetailRow>
        <LabeledDetail
          title={t(($) => $.stopDetails.signs.signType)}
          detail={signType}
          testId={testIds.signType}
        />
        <LabeledDetail
          title={t(($) => $.stopDetails.signs.numberOfFrames)}
          detail={generalSign?.numberOfFrames?.toString()}
          testId={testIds.numberOfFrames}
        />
        <LabeledDetail
          title={t(($) => $.stopDetails.signs.signageInstructionExceptions)}
          className="max-w-[500px]"
          detail={generalSign?.note?.value}
          testId={testIds.signageInstructionExceptions}
        />
      </DetailRow>
      <DetailRow>
        <LabeledDetail
          title={t(($) => $.stopDetails.signs.replacesRailSign)}
          detail={optionalBooleanToUiText(t, generalSign?.replacesRailSign)}
          testId={testIds.replacesRailSign}
        />
      </DetailRow>
    </div>
  );
};
